﻿import assign from 'object-assign';
import * as types from './ImageEditorActionTypes';
import initialState from './ImageEditorInitialState';

export default function imageEditorReducer(
    state: any = initialState.imageEditors,
    action: { type: string; userResult: any; id: number; result: any }
) {
    switch (action.type) {
        case types.LOAD_IMAGE_EDITORS_SUCCESS:
            return {
                ...state,
                list: action.userResult
            };

        case types.ADD_IMAGE_EDITOR_USER_SUCCESS:
            return {
                ...state,
                list: [...state.list, action.userResult]
            };

        case types.DELETE_IMAGE_EDITOR_USER_SUCCESS:
            return {
                ...state,
                list: [...state.list.filter((user: any) => user.id !== action.id)]
            };

        case types.UPDATE_IMAGE_EDITOR_USER_SUCCESS:
            return {
                ...state,
                list: [
                    ...state.list.filter((x: any) => x.id !== action.userResult.id),
                    action.userResult
                ]
            };

        case types.GET_EDIT_IMAGE_EDITOR_SUCCESS:
            return {
                ...state,
                edit: action.userResult.imageEditor,
                modal: {
                    ...state.modal,
                    imageEditorFirms: action.userResult.imageEditorFirms,
                    availableLanguages: action.userResult.availableLanguages,
                    availableRoles: action.userResult.availableRoles
                }
            };

        case types.GET_NEW_IMAGE_EDITOR_SUCCESS:
            return {
                ...state,
                modal: {
                    ...state.modal,
                    imageEditorFirms: action.result.imageEditorFirms,
                    availableLanguages: action.result.availableLanguages,
                    availableRoles: action.result.availableRoles
                }
            };

        default:
            return state;
    }
}
